let prot = window.location.protocol;

let env = process.env;
let config = {
    env:env.VUE_APP_ENV,
    app_name: env.VUE_APP_NAME,
    default_domin: prot+env.VUE_APP_DEFAULT_DOMAIN,
    magh_domin: prot+env.VUE_APP_MAGH_DOMAIN,
    neigou_domin: prot+env.VUE_APP_NEIGOU_DOMAIN,
    cas_domin: prot+env.VUE_APP_CAS_DOMAIN,
    agh_cas_domin: prot+env.VUE_APP_AGH_CAS_DOMAIN,
    qy_wx_weuit: prot+env.VUE_APP_QY_WX_WEUIT,
    b_api_domain: prot+env.VUE_APP_B_API_DOMAIN,
    m_domain: prot+env.VUE_APP_M_DOMAIN,
    apps_domain: prot+env.VUE_APP_APPS_DOMAIN,
    m_api_domain: prot+env.VUE_APP_M_API_DOMAIN,
    client_domain: prot+env.VUE_APP_CLIENT_DOMAIN,
    api_app_domain: prot+env.VUE_APP_API_APP_DOMAIN,
    token_header_name: prot+env.VUE_APP_TOKEN_HEADER_NAME,
    token_cookie_name: prot+env.VUE_APP_TOKEN_COOKIE_NAME,
    project_name: env.VUE_APP_PROJECT
};
export default config;
